<template>
    <div class="relation">
        <div class="kgr-postfix  kgr-postfix--center kgr-postfix--gutters kgr-row relation-row animated fadeIn">
            <div class="kgr-postfix__fixed">
                <kgr-profile-image
                    :src="memberAvatarUrl"
                    :alt="relation.member.fullName()"
                    size="S"
                />
            </div>

            <div class="kgr-postfix__fluid">
                <a
                    :href="memberUrl"
                    class="kgr-link kgr-link--unobtrusive"
                >
                    {{ relation.member.fullName() }}
                </a>
            </div>
            <div
                v-if="isDeletable"
                class="kgr-postfix__fixed"
            >
                <kgr-button
                    type="red"
                    :value="$t('Zugehörigkeit entfernen')"
                    :pending="pendingRemove"
                    @click="$emit('remove')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DogMemberRelation from '../../js/dto/DogMemberRelation.js';
import KgrButton from '../common/form/button/KgrButton.vue';
import ProfileImage from '../common/ProfileImage.vue';
import UrlMixin from '../members/UrlMixin.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-profile-image': ProfileImage,
    },
    mixins: [UrlMixin],
    props: {
        relation: {
            type: DogMemberRelation,
            required: true,
        },
        pendingRemove: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        memberUrl() {
            return this.urlForMember(this.relation.member.id);
        },
        memberAvatarUrl() {
            return this.avatarUrl(
                this.relation.member.id,
                this.relation.member.hasAvatar,
                this.relation.member.gender,
                this.relation.member.avatarFileName,
            );
        },
    },
    methods: {
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.relation-row {
    margin-top: 4px;
    padding-left: 4px;
}

.relation-link {
    float: left;
    line-height: 3;
}

.buttons {
    float: right;
    margin-top: 8px;
    margin-right: 4px;

    & > a {
        margin-right: 5px;
    }
}

.avatar {
    border-width: medium;
    margin-top: 0;
    margin-bottom: 0;
    width: 40px;
    height: 40px;
}

.link {
    cursor: pointer;
}
</style>
